module.exports = __webpack_public_path__ + "static/media/084-barbados.1e66dccd.svg";